module.exports = __webpack_public_path__ + "assets/img/37_1431.5548724e.jpg";